<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="activeNames(activeName)">
    <el-tab-pane label="客服聊天" name="first">
    <div style="min-width:1290px;height:750px;overflow-x:scroll;background-color:#f1f2f7;">
    <div class="used_list" v-if="used_list && used_list.length>0">
      <ul v-if="used_list && used_list.length>0">
          <li v-for="(item,index) in used_list" v-on:click="add_message_value(item.value)">
            {{index+1 + '、' + item.value}}
          </li>
      </ul>
    </div>
    <div class="chat_dig">
      <div v-if="content_room && content_room.room_id" class="kefu_jilu">
        <div class="chat_window">
          <div class="top_menu">
              <div class="buttons">
                  <div class="button close"></div>
                  <div class="button minimize"></div>
                  <div class="button maximize"></div>
              </div>
              <div class="title" :style="(content_room.is_online==1?'color:#0c0':'')">{{content_room.user_name}}</div>
              <div class="buttons_right">
                  <i class="el-icon-delete" title="消息太多，清空聊天框" v-on:click="clean_content()"></i>
                  <i class="el-icon-document" title="聊天记录" v-on:click="open_histroy()"></i>
                  <i class="el-icon-error" style="color:#f00;" title="关闭聊天" v-on:click="close_content()"></i>
              </div>
          </div>
          <ul class="messages" id="messages">
            <li v-for="(item,index) in content_room.content_list" :class="'message '+ (item.type==2?'right':'left') +' appeared'">
                <div class="avatar"><img :src="item.type==2?logo2:logo1" alt="" style="width:100%;height:100%;"></div>
                <div class="text_wrapper" @contextmenu.prevent="rightClick($event, item, index)">
                    <div class="text" v-if="item.recall!=1">{{item.content}}</div>
                    <div class="text" v-if="item.recall==1" style="color:#f00;font-size:14px;text-align:center;">
                        <span v-if="item.type==2">本消息已撤回，可<el-button size="text" class="m-l-10" @click="set_contents(item.content)">重新编辑</el-button></span>
                        <span v-if="item.type==1">对方撤回了一条消息</span>
                      </div>
                </div>
                <div class="time">{{item.create_time}}</div>
            </li>
          </ul>
          <div class="bottom_wrapper clearfix" v-for="item in room_list" v-if="item.id==content_room_id">
              <div class="message_input_wrapper">
                  <input class="message_input" v-model="item.content" placeholder="在此处输入您的消息" />
                  <i v-if="item.content" class="el-icon-circle-close" title="清空" v-on:click="item.content = ''"></i>
              </div>
              <div class="send_message" v-on:click="send_message(item)">
                  <div class="icon"></div>
                  <div class="text">发送</div>
              </div>
          </div>
        </div>
        <div class="message_template">
            <li class="message">
                <div class="avatar"></div>
                <div class="text_wrapper">
                    <div class="text"></div>
                </div>
            </li>
        </div>
      </div>
      <div v-if="!content_room || !content_room.room_id" class="kefu_none">
        请在用户列表选择要联系的用户，或者等待用户主动联系你（勿离开此页面）
      </div>
    </div>
    <div class="room_list" v-if="content_room && content_room.room_id">
      <ul v-if="room_list && room_list.length>0">
          <li v-for="item in room_list" :class="(item.id==content_room_id)?'room_active':''" v-on:click="read_content(item)">
            <img :src="logo1" class="head" alt="">
            <div class="user_name" :style="(item.is_online==1?'color:#0c0':'')">{{item.user_name}}</div>
            <div class="last_time">{{time_chaju(item.last_time)}}</div>
            <div class="last_content"><span v-if="!item.content">{{item.last_content}}</span><span v-if="item.content"><span v-if="item.id!=content_room_id" style="color:#f00;">草稿：{{item.content}}</span><span v-if="item.id==content_room_id">{{item.last_content}}</span></span></div>
            <el-badge v-if="item.kefu_no_read>0" :value="(item.kefu_no_read>99)?'99+':item.kefu_no_read" class="item">
              <div class="no_read"></div>
            </el-badge>
          </li>
      </ul>
    </div>
    </div>
    </el-tab-pane>
    <el-tab-pane label="用户列表" name="second">
      <div class="user_list">
        <div style="width:100%;">
          <el-input placeholder="请输入账号/真实姓名" clearable v-model="keywords" class="w-300">
            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
          </el-input>
          <el-checkbox v-model="new_service" v-on:change="search()">最近在聊</el-checkbox>
        </div>
        <el-table
          :data="tableData"
          :height="setHeight.pane_height"
          style="width: 100%"
          border>
            <el-table-column
            prop="id"
            label="ID">
            </el-table-column>
            <el-table-column
            prop="user_head"
            label="头像">
              <template scope="scope">
                <el-popover
                  placement="right-end"
                  width="400"
                  trigger="click">
                  <img :src="scope.row.user_head?scope.row.user_head:logo2" width="100%">
                  <img :src="scope.row.user_head?scope.row.user_head:logo2" width="50" height="50" slot="reference">
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
            prop="username"
            label="账号">
            </el-table-column>
            <el-table-column
            prop="user_name"
            label="真实姓名">
            </el-table-column>
            <el-table-column
            prop="realname"
            label="最近聊天客服">
            </el-table-column>
            <el-table-column
            prop="last_time"
            label="最近聊天时间">
            </el-table-column>
            <el-table-column
            label="操作"
            width="300">
              <template scope="scope">
                <div>
                  <span>
                    <el-button size="small" type="success" @click="start_service(scope.row.id)">发起聊天</el-button>
                    <el-button size="small" type="primary" @click="send_notice_user(scope.row)">发送通知</el-button>
                    <el-button size="small" type="primary" @click="open_notice_user(scope.row)">通知记录</el-button>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="pos-rel p-t-20">
        <div class="block fr">
          <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :page-size="limit"
          :current-page="currentPage"
          :total="dataCount">
          </el-pagination>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="全体通知" name="third">
      <div class="fr">
        <el-button type="success" size="small" @click="open_notice_dig()">发送全体通知</el-button>
      </div>
      <div style="width:100%;">
        <el-input placeholder="请输入标题/内容" clearable v-model="keywords3" class="w-300">
          <el-button slot="append" icon="el-icon-search" @click="search3()"></el-button>
        </el-input>
      </div>
      <el-table
        :data="tableData3"
        :height="setHeight.page_height-80"
        style="width: 100%"
        border>
          <el-table-column
          prop="id"
          label="ID">
          </el-table-column>
          <el-table-column
          prop="name"
          label="标题">
          </el-table-column>
          <el-table-column
          label="内容">
            <template scope="scope" :show-overflow-tooltip="true">
              <div v-html="scope.row.value"></div>
            </template>
          </el-table-column>
          <el-table-column
          prop="create_time"
          label="发送时间">
          </el-table-column>
          <el-table-column
          label="状态">
            <template scope="scope">
              <div>
                <span v-if = "scope.row.status ==1" style="color:#0c0">正常</span>
                <span v-else-if = "scope.row.status ==0"  style="color:#bb0">{{ scope.row.status | status }}</span>
                <span v-else-if = "scope.row.status ==-1" style="color:#d00">{{ scope.row.status | status }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
          label="操作"
          width="120">
            <template scope="scope">
              <div>
                <span>
                  <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pos-rel p-t-20">
          <btnGroup :selectedData="multipleSelection" :type="'used'"></btnGroup>
          <div class="block pages">
            <el-pagination
            @current-change="handleCurrentChange3"
            layout="prev, pager, next"
            :page-size="limit3"
            :current-page="currentPage3"
            :total="dataCount3">
            </el-pagination>
          </div>
        </div>
    </el-tab-pane>
    </el-tabs>
    <el-dialog :title="content_room.user_name + '的聊天记录'" class="chat_dig_his" :visible.sync="histroy_open" custom-class="w-800" size="tiny">
      <ul v-if="message_list && message_list.length>0" class="his_messages" id="his_messages">
        <li v-for="item in message_list" :class="'message '+ (item.type==2?'right':'left') +' appeared'">
            <div class="avatar"><img :src="item.type==1?logo1:logo2" alt="" style="width:100%;height:100%;"></div>
            <div class="text_wrapper">
                <div class="text" v-html="item.content"></div>
            </div>
        </li>
      </ul>
      <div v-if="!message_list || message_list.length==0" class="no_his_message">
        <p class="error_status">没有聊天记录</p>
      </div>
      <!-- <el-table
      :data="message_list"
      :height="setHeight.page_height"
      style="width: 100%"
      border>
        <el-table-column
        label="客服"
        width="100">
        <template scope="scope">
            <span v-if = "scope.row.type ==2">{{scope.row.realname}}</span>
        </template>
        </el-table-column>
        <el-table-column
        label="用户"
        width="100">
        <template scope="scope">
            <span v-if = "scope.row.type ==1">{{scope.row.user_name}}</span>
        </template>
        </el-table-column>
        <el-table-column
        label="内容"
        :show-overflow-tooltip="true">
        <template scope="scope">
            <span v-if = "scope.row.type ==1" style="color:#c48843;">{{scope.row.content}}</span>
            <span v-if = "scope.row.type ==2" style="color:#00f;">{{scope.row.content}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="create_time"
        label="时间"
        width="160"
        :show-overflow-tooltip="true">
        </el-table-column>
      </el-table> -->
    </el-dialog>
    <el-dialog :title="notice_user_name + '的通知记录'" :visible.sync="user_notice_open" size="tiny">
      <div style="width:100%;">
        <el-input placeholder="请输入通知标题/内容" clearable v-model="keywords2_1" class="w-300">
          <el-button slot="append" icon="el-icon-search" @click="search2_1()"></el-button>
        </el-input>
      </div>
      <el-table
        :data="tableData2_1"
        :height="600"
        style="width: 100%"
        border>
          <el-table-column
          prop="id"
          label="ID">
          </el-table-column>
          <el-table-column
          prop="realname"
          label="发送人" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
          prop="name"
          label="标题" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
          label="内容">
            <template scope="scope" :show-overflow-tooltip="true">
              <div v-html="scope.row.value"></div>
            </template>
          </el-table-column>
          <el-table-column
          prop="create_time"
          width="170"
          label="通知时间">
          </el-table-column>
          <el-table-column
          label="状态">
            <template scope="scope">
              <div>
                <span v-if = "scope.row.is_read ==1" style="color:#0c0">已读</span>
                <span v-else  style="color:#d00">未读</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pos-rel p-t-20">
          <div class="block pages">
            <el-pagination
            @current-change="handleCurrentChange2_1"
            layout="prev, pager, next"
            :page-size="limit2_1"
            :current-page="currentPage2_1"
            :total="dataCount2_1">
            </el-pagination>
          </div>
        </div>
    </el-dialog>
    <el-dialog title="编写通知内容" :visible.sync="notice_open" size="tiny">
      <el-form ref="notice_form" :model="notice_form" label-width="20%" :rules="rules">
        <el-form-item label="接收人" :label-width="formLabelWidth">
          <span>{{(notice_form.user_id==0)?'全体用户':notice_name}}</span>
        </el-form-item>
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input v-model.trim="notice_form.name" placeholder="" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="内容" :label-width="formLabelWidth">
          <el-input v-model.trim="notice_form.value" placeholder="" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="是否紧急" :label-width="formLabelWidth">
          <el-checkbox v-model.trim="notice_form.is_urgent">紧急</el-checkbox><span class="error_status m-l-50"> 勾选紧急后，通知将会拉起用户的通知弹窗</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="notice_open = false" size="small">取 消</el-button>
        <el-button type="primary" @click="send_notice()" size="small">发 送</el-button>
      </div>
    </el-dialog>
    <div class="right-menu" ref="rightMenu" v-show="rightMenu" style="z-index:999999999999999;">
      <div :class="['menu-item']" v-if="activeMenuItem.content && activeMenuItem.recall!=1" @click="copy_text(activeMenuItem.content, '消息')">
          <span class="menu-item_licon iconfont icon-guanbiqita"></span>复制消息
      </div>
      <div :class="['menu-item']" @click="cehui_message($event)" v-if="time_check()==true">
          <span class="menu-item_licon iconfont icon-guanbiqita"></span>撤回消息
      </div>
    </div>
  </div>
</template>
<script>
  import http from '../../../../assets/js/http'
  import { sendSock, createWebSocket, closeSock } from "../../../../assets/js/socket"
  import logo1 from '../../../../assets/images/logo1.png'
  import logo2 from '../../../../assets/images/logo2_1.png'
  import btnGroup from '../../../Common/btn-notice-group.vue'

  export default {
    data() {
      return {
        activeName: 'first',
        open_kefu_function: false,
        logo1: '',
        logo2: '',
        send_message_value: '',
        used_list: [],
        room_list: [],
        content_room_id: '',
        content_room: {
          user_name: '',
          room_id: '',
          content: '',
          is_online: 0,
          content_list: [],
        },
        chat_token: '',
        histroy_open: false,
        message_list: [],
        new_service: true,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        limit: 15,
        tableData3: [],
        dataCount3: null,
        currentPage3: null,
        keywords3: '',
        limit3: 15,
        notice_open: false,
        notice_form: {
          name: '',
          value: '',
          user_id: 0,
          is_urgent: false
        },
        notice_name: '',
        notice_user_name: '',
        user_notice_open: false,
        tableData2_1: [],
        dataCount2_1: null,
        currentPage2_1: null,
        keywords2_1: '',
        limit2_1: 15,
        rightMenu: false,
        activeMenuIndex: 0,
        activeMenuItem: [],
        send_reload: false
      }
    },
    methods: {
      search() {
        this.currentPage = 1
        this.get_user_list()
      },
      handleCurrentChange(page) {
        this.currentPage = page
        this.get_user_list()
      },
      get_user_list() {
        this.loading = true
        const data = {
          params: {
            new_service: this.new_service,
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/service/get_user_list', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      search3() {
        this.currentPage3 = 1
        this.get_all_list3()
      },
      handleCurrentChange3(page) {
        this.currentPage3 = page
        this.get_all_list3()
      },
      get_all_list3() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords3,
            page: this.currentPage3,
            limit: this.limit3
          }
        }
        this.apiGet('admin/notice', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData3 = data.list
            this.dataCount3 = data.dataCount
          })
        })
      },
      search2_1() {
        this.currentPage2_1 = 1
        this.get_user_list2_1()
      },
      handleCurrentChange2_1(page) {
        this.currentPage2_1 = page
        this.get_user_list2_1()
      },
      get_user_list2_1() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords2_1,
            page: this.currentPage2_1,
            limit: this.limit2_1,
            uid: this.notice_user_id
          }
        }
        this.apiGet('admin/service/get_user_notice', data).then((res) => {
          this.handelResponse(res, (data) => {
            this.tableData2_1 = data.list
            this.dataCount2_1 = data.dataCount
            this.user_notice_open = true
          })
        })
      },
      confirmDelete(item) {
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/notice/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        this.apiGet('admin/service').then((res) => {
          this.handelResponse(res, (data) => {
            this.used_list = data.used_list
            this.open_kefu_function = data.open_kefu_function
            let user = Lockr.get('userInfo')
            this.chat_token = user.chat_token
            if (this.chat_token) {
              this.initWebSocket()
            }
          })
        }).catch(() => {
          this.initWebSocket()
        })
      },
      open_histroy() {
        this.apiGet('admin/service/get_user_message?id=' + this.content_room_id).then((res) => {
          this.handelResponse(res, (data) => {
            this.message_list = data.list
            this.histroy_open = true
          })
        })
      },
      initWebSocket(e) {
        createWebSocket(this.global_callback);
      },
      global_callback(msg) {
        // console.log("websocket的回调函数收到服务器信息：" + JSON.stringify(msg));
        if (msg.code == 400) {
          _g.toastMsg('error', msg.msg)
        }
        if (msg.type == 'login') {
          if (!this.open_kefu_function) {
            _g.toastMsg('error', '非客服岗位禁止使用客服聊天功能')
            return false
          }
          this.send_contact()
        }
        if (msg.type == 'kefu_login') {
          this.room_list = msg.room_list
          if (this.room_list.length > 0) {
            this.content_room_id = this.room_list[0].id
            this.content_room.user_name = this.room_list[0].user_name
            this.content_room.room_id = this.room_list[0].room_id
            this.content_room.content = this.room_list[0].content
            this.content_room.content_list = this.room_list[0].content_list
            this.content_room.is_online = this.room_list[0].is_online
            this.send_no_read()
            setTimeout(() => {
              var div = document.getElementById('messages');
              div.scrollTop = div.scrollHeight;
            }, 500)
          } else {
            this.activeNames('second')
          }
        }
        if (msg.type == 'user_send') { //接收用户发送来的消息
          var is_find = false
          let room = msg.room
          if (this.room_list.length > 0) {
            this.room_list.forEach((res, index) => {
              if (res.id == room.id) {
                if (room.content_list && room.content_list.length > 0) {
                  room.content_list.forEach((ret, i) => {
                    res.content_list.push(ret)
                  })
                }
                res.last_content = room.last_content
                res.last_time = room.last_time
                res.kefu_no_read = room.kefu_no_read
                res.is_online = room.is_online
                res.user_name = room.user_name
                if (index != 0) {
                  this.room_list.unshift(this.room_list.splice(index, 1)[0])
                }
                if (this.content_room_id == room.id) {
                  this.content_room.user_name = room.user_name
                  res.kefu_no_read = 0
                  this.send_no_read()
                }
                is_find = true
              }
              if (index == (this.room_list.length - 1)) {
                if (!is_find) {
                  this.room_list.splice(0, 0, room)
                }
                setTimeout(() => {
                  var div = document.getElementById('messages');
                  div.scrollTop = div.scrollHeight;
                }, 500)
              }
            })
          } else {
            this.room_list.splice(0, 0, room)
            this.content_room_id = room.id
            this.content_room.user_name = room.user_name
            this.content_room.room_id = room.room_id
            this.content_room.content = room.content
            this.content_room.content_list = room.content_list
            this.content_room.is_online = room.is_online
            setTimeout(() => {
              var div = document.getElementById('messages');
              div.scrollTop = div.scrollHeight;
            }, 500)
          }
        }
        if (msg.type == 'kefu_add_user') { //主动给用户发消息
          if (this.activeName != 'first') {
            this.activeNames('first');
          }
          var is_finds = false
          let room = msg.room
          if (this.room_list.length > 0) {
            this.room_list.forEach((res, index) => {
              if (res.id == room.id) {
                if (room.content_list && room.content_list.length > 0) {
                  room.content_list.forEach((ret, i) => {
                    res.content_list.push(ret)
                  })
                }
                res.last_content = room.last_content
                res.last_time = room.last_time
                res.kefu_no_read = room.kefu_no_read
                if (index != 0) {
                  this.room_list.unshift(this.room_list.splice(index, 1)[0])
                }
                if (this.content_room_id == room.id) {
                  this.send_no_read()
                }
                is_finds = true
              }
              if (index == (this.room_list.length - 1)) {
                if (!is_finds) {
                  this.room_list.splice(0, 0, room)
                }
                this.content_room_id = room.id
                this.content_room.user_name = room.user_name
                this.content_room.room_id = room.room_id
                this.content_room.content = room.content
                this.content_room.content_list = room.content_list
                this.content_room.is_online = room.is_online
                setTimeout(() => {
                  var div = document.getElementById('messages');
                  div.scrollTop = div.scrollHeight;
                }, 500)
              }
            })
          } else {
            this.room_list.splice(0, 0, room)
            this.content_room_id = room.id
            this.content_room.user_name = room.user_name
            this.content_room.room_id = room.room_id
            this.content_room.content = room.content
            this.content_room.content_list = room.content_list
            this.content_room.is_online = room.is_online
            setTimeout(() => {
              var div = document.getElementById('messages');
              div.scrollTop = div.scrollHeight;
            }, 500)
          }
        }
        if (msg.type == 'kefu_send') {
          this.room_list.forEach((res, index) => {
            if (res.id == msg.room_id) {
              res.content_list.push(msg.content)
            }
          })
          setTimeout(() => {
            var div = document.getElementById('messages');
            div.scrollTop = div.scrollHeight;
          }, 500)
        }
        if (msg.type == 'user_recall') {
          this.room_list.forEach((ret) => {
            if (ret.id == msg.room_id) {
              ret.content_list.forEach((res) => {
                if (res.id == msg.content_id) {
                  res.recall = 1
                  res.content = ''
                  ret.last_content = '对方撤回了一条消息'
                }
              })
            }
          })
        }
        if (msg.type == 'user_is_online') {
          this.room_list.forEach((res, index) => {
            if (res.id == msg.room_id) {
              res.is_online = msg.is_online
              if (this.content_room_id == msg.room_id) {
                this.content_room.is_online = msg.is_online
              }
            }
          })
        }
        return
      },
      //连接
      send_contact() {
        const data = {
          type: 'kefu_login',
          token: this.chat_token
        }
        var post_data = JSON.stringify(data);
        sendSock(post_data)
        return true
      },
      send_message(item) {
        if (!item.content) {
          _g.toastMsg('error', '请输入内容')
          return
        }
        if (this.send_reload) {
          _g.toastMsg('error', '消息发送中')
          return
        }
        this.send_reload = true
        let send_time = this.formatDate()
        const data = {
          type: 'kefu_send',
          token: this.chat_token,
          room_id: item.id,
          content: item.content,
          create_time: send_time,
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
        item.last_content = item.content
        item.last_time = send_time
        item.kefu_no_read = 0
        item.content = ''
        this.send_reload = false
        return true
      },
      send_message_no() {
        this.room_list.forEach((ret) => {
          if (ret.id == this.content_room_id) {
            this.send_message(ret)
          }
        })
      },
      //展示消息并发送已阅读
      read_content(item) {
        this.content_room_id = item.id
        this.content_room.user_name = item.user_name
        this.content_room.room_id = item.room_id
        this.content_room.content = item.content
        this.content_room.content_list = item.content_list
        this.content_room.is_online = item.is_online
        if (item.kefu_no_read > 0) {
          item.kefu_no_read = 0
          this.send_no_read()
        }
        this.look_is_online()
        return true
      },
      look_is_online() {
        const data = {
          type: 'user_is_online',
          token: this.chat_token,
          room_id: this.content_room_id
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
        return true
      },
      send_no_read() {
        const data = {
          type: 'kefu_no_read',
          token: this.chat_token,
          room_id: this.content_room_id
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
        return true
      },
      close_content() {
        this.room_list.forEach((res, index) => {
          if (res.id == this.content_room_id) {
            this.room_list.splice(index, 1)
            this.send_close()
            this.reload_room(index + 1)
          }
        })
      },
      send_close() {
        const data = {
          type: 'kefu_close',
          token: this.chat_token,
          room_id: this.content_room_id
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
        return true
      },
      set_contents(content) {
        for (let index1 = 0; index1 < this.room_list.length; index1++) {
          this.content_room_id = this.room_list[index1].id
          if (this.content_room_id == this.room_list[index1].id) {
            this.room_list[index1].content = content
          }
          break
        }
      },
      reload_room(index = 0) {
        if (this.room_list && this.room_list.length > 0) {
          if (this.room_list[index]) {
            this.content_room_id = this.room_list[index].id
            this.content_room.user_name = this.room_list[index].user_name
            this.content_room.room_id = this.room_list[index].room_id
            this.content_room.content = this.room_list[index].content
            this.content_room.content_list = this.room_list[index].content_list
            this.content_room.is_online = this.room_list[index].is_online
            setTimeout(() => {
              var div = document.getElementById('messages');
              div.scrollTop = div.scrollHeight;
            }, 500)
          } else {
            for (let index1 = 0; index1 < this.room_list.length; index1++) {
              this.content_room_id = this.room_list[index1].id
              this.content_room.user_name = this.room_list[index1].user_name
              this.content_room.room_id = this.room_list[index1].room_id
              this.content_room.content = this.room_list[index1].content
              this.content_room.content_list = this.room_list[index1].content_list
              this.content_room.is_online = this.room_list[index1].is_online
              setTimeout(() => {
                var div = document.getElementById('messages');
                div.scrollTop = div.scrollHeight;
              }, 500)
              break
            }
          }
        } else {
          this.content_room_id = ''
          this.content_room.user_name = ''
          this.content_room.room_id = ''
          this.content_room.content = ''
          this.content_room.is_online = 0
          this.content_room.content_list = []
          this.activeNames('second')
          setTimeout(() => {
            var div = document.getElementById('messages');
            div.scrollTop = div.scrollHeight;
          }, 500)
        }
        return true
      },
      start_service(id) {
        if (!this.open_kefu_function) {
          _g.toastMsg('error', '非客服岗位禁止使用')
          return false
        }
        var is_have = false
        if (this.room_list && this.room_list.length > 0) {
          this.room_list.forEach((res, index) => {
            if (res.user_id == id) {
              this.content_room_id = this.room_list[index].id
              this.content_room.user_name = this.room_list[index].user_name
              this.content_room.room_id = this.room_list[index].room_id
              this.content_room.content = this.room_list[index].content
              this.content_room.content_list = this.room_list[index].content_list
              this.content_room.is_online = this.room_list[index].is_online
              is_have = true
              this.activeNames('first')
            }
            if ((index + 1) == this.room_list.length) {
              if (!is_have) {
                const data = {
                  type: 'kefu_add_user',
                  token: this.chat_token,
                  user_id: id
                }
                var post_data = JSON.stringify(data)
                sendSock(post_data)
              } else {
                this.activeNames('first')
              }
            }
          })
        } else {
          const data = {
            type: 'kefu_add_user',
            token: this.chat_token,
            user_id: id
          }
          var post_data = JSON.stringify(data)
          sendSock(post_data)
        }
        return true
      },
      add_message_value(values) {
        if (this.room_list && this.room_list.length > 0) {
          this.room_list.forEach((res, index) => {
            if (res.id == this.content_room_id) {
              res.content = res.content + '' + values
            }
          })
        }
      },
      open_notice_dig() {
        if (this.notice_form.user_id != 0) {
          this.notice_form.user_id = 0
          this.notice_form.name = ''
          this.notice_form.value = ''
          this.notice_form.is_urgent = false
        }
        this.notice_open = true
      },
      send_notice_user(item) {
        this.notice_name = item.user_name
        this.notice_form.name = ''
        this.notice_form.value = ''
        this.notice_form.user_id = item.id
        this.notice_form.is_urgent = false
        this.notice_open = true
      },
      send_notice() {
        if (!this.notice_form.name) {
          _g.toastMsg('error', '请输入通知标题')
          return
        }
        if (!this.notice_form.value) {
          _g.toastMsg('error', '请输入通知内容')
          return
        }
        const data = {
          type: 'notice_send',
          token: this.chat_token,
          content: this.notice_form,
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
        _g.toastMsg('success', '发送成功')
        this.notice_open = false
        this.notice_form.name = ''
        this.notice_form.value = ''
        this.notice_form.user_id = 0
        this.notice_form.is_urgent = false
        return true
      },
      open_notice_user(item) {
        this.notice_user_name = item.user_name
        this.notice_user_id = item.id
        this.get_user_list2_1()
      },
      copy_text(text, alert) {
        this.$copyText(text).then(function (e) {
          _g.toastMsg('success', '复制 ' + alert + ' 成功')
        }, function (e) {
          _g.toastMsg('error', '复制 ' + alert + ' 失败')
        })
      },
      clean_content() {
        this.room_list.forEach((res, index) => {
          if (res.id == this.content_room_id) {
            res.content_list = []
            res.last_content = ''
            this.content_room.content_list = []
          }
        })
      },
      rightClick(event, item, index) {
        let _this = this
        event = event || window.event
        //屏蔽样式
        event.preventDefault
            ? event.preventDefault()
            : (event.returnValue = false)
        //获取坐标
        var x = event.clientX //视口的位置
        var y = event.clientY
        _this.activeMenuIndex = index
        _this.activeMenuItem = item
        // _this.$set(_this, 'activeMenuItem', item)

        _this.$nextTick(() => {
          _this.rightMenu = true

          let myRightMouseMenu = _this.$refs.rightMenu
          //页面高度
          let bodyHeight = document.body.offsetHeight
          //显示菜单位置
          myRightMouseMenu.style.top = y - 50 + 'px'
          myRightMouseMenu.style.left = x - 170 + 'px'
          // 监听-点击菜单之外区域时，隐藏
          document.body.addEventListener('click', _this.hideMenu)
        })
      },
      hideMenu(event) {
        let _this = this
        event = event || window.event
        event.stopPropagation()
        event.preventDefault()
        _this.rightMenu = false
        // 清除监听-点击菜单之外区域时，隐藏
        document.body.removeEventListener('click', _this.hideMenu)
      },
      cehui_message(event) {
        this.content_room.content_list[this.activeMenuIndex].recall = 1
        const data = {
          type: 'kefu_recall',
          token: this.chat_token,
          room_id: this.content_room_id,
          create_time: this.activeMenuItem.create_time,
        }
        var post_data = JSON.stringify(data)
        sendSock(post_data)
      },
      time_check() {
        let StartTime = new Date(this.activeMenuItem.create_time).getTime() //时间
        let now_time = new Date().getTime()-120000
        if (StartTime > now_time && this.activeMenuItem.type == 2) {
          return true
        } else {
          return false
        }
      },
      formatDate () {
        const date = new Date()
        let Y = date.getFullYear()
        let M = date.getMonth() + 1 // 月
        let D = date.getDate() // 日
        let H = date.getHours() // 时
        let I = date.getMinutes() // 分
        let S = date.getSeconds() // 秒
        return Y+'-'+M+'-'+D+' '+H+':'+I+':'+S
      },
      time_chaju(date2 = '2008-08-08 08:08:08') {//建立一个方法来进行计算
        var date1 = new Date()
        var time10 = new Date(new Date().toLocaleDateString()).getTime() //今天0点
        var time20 = time10 - 86400000 //昨天0点
        var time1 = Date.parse(date1) //将日期转换成毫秒值
        var time2 = Date.parse(date2)
        var time3 = time1 - time2 //毫秒值进行计算
        var minute = time3 / 1000 / 60 //分钟
        if (minute < 1) {
          return '刚刚'
        }
        if (minute >= 1 && minute < 10) {
          return Math.floor(minute) + '分钟前'
        }
        if (minute >= 10 && time2 >= time10) {
          return date2.slice(11, 16)
        }
        if (time2 < time20) {
          return date2.slice(5, 10)
        }
        if (time2 < time10) {
          return '昨天'
        }
      },
      activeNames (name) {
        this.activeName = name
        if (name == 'second') {
          this.get_user_list()
        }
        if (name == 'third') {
          this.get_all_list3()
        }
        if (name == 'first') {
          setTimeout(() => {
            var div = document.getElementById('messages');
            div.scrollTop = div.scrollHeight;
          }, 500)
        }
        return true
      },
      init() {
        this.getAllUsers()
        const self = this
        document.onkeydown = function(e) {
          let key = window.event.keyCode
          if (key == 13) {
            if (self.activeName == 'first') {
              self.send_message_no()
            }
            if (self.activeName == 'second') {
              self.get_user_list()
            }
            if (self.activeName == 'third') {
              self.get_all_list3()
            }
          }
        }
      }
    },
    created() {
      this.logo1 = logo1
      this.logo2 = logo2
      this.init()
    },
    computed: {
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>

<style>
.chat_dig{
  width:758px;
  height:700px;
  float: left;

}
.chat_dig .kefu_none{
  width:100%;
  height:700px;
  line-height:700px;
  color:#f00;
  text-align: center;
}
.chat_dig .kefu_jilu{
    width:758px;
    height:700px;
    /* border: 1px solid #f1f2f7; */
    /* overflow-y: scroll; */
  }
  .chat_dig .kefu_jilu * {
    box-sizing: border-box;
}
.chat_dig .kefu_jilu .chat_window {
    position: absolute;
    width: 740px;
    height: 700px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    background-color: #f8f8f8;
    overflow: hidden;
}
.chat_dig .kefu_jilu .top_menu {
    background-color: #fff;
    width: 660px;
    height:50px;
    padding: 0px;
    box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
}
.chat_dig .kefu_jilu .top_menu .buttons {
    margin: 0px 0 0 20px;
    position: absolute;
}
.chat_dig .kefu_jilu .top_menu .buttons .button {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
    position: relative;
}
.chat_dig .kefu_jilu .top_menu .buttons .button.close {
    background-color: #f5886e;
}
.chat_dig .kefu_jilu .top_menu .buttons .button.minimize {
    background-color: #fdbf68;
}
.chat_dig .kefu_jilu .top_menu .buttons .button.maximize {
    background-color: #a3d063;
}
.chat_dig .kefu_jilu .top_menu .title {
    width: 450px;
    text-align: center;
    color: #bcbdc0;
    font-size: 20px;
    margin-top:-4px;
    white-space:nowrap;
    overflow: hidden; 
    text-overflow:ellipsis;
}
.chat_dig .kefu_jilu .top_menu .buttons_right {
    margin: 0px 0 0 20px;
    position: absolute;
    right: 55px;
    top:-3px;
    font-size:22px;
    color:#111;
}
.chat_dig .kefu_jilu .top_menu .buttons_right i{
    margin-left: 8px;
}
.chat_dig .kefu_jilu .messages {
    position: relative;
    list-style: none;
    padding: 20px 10px 0 10px;
    margin: 0;
    width:750px;
    height: 555px;
    overflow: scroll;
}
.chat_dig .kefu_jilu .messages .message {
    clear: both;
    overflow: hidden;
    margin-bottom: 20px;
    transition: all 0.5s linear;
    opacity: 0;
    position: relative;
}
.chat_dig .kefu_jilu .messages .message.left .avatar {
    /* background-color: #f5886e; */
    float: left;
}
.chat_dig .kefu_jilu .messages .message.left .text_wrapper {
    background-color: #ffe6cb;
    margin-left: 20px;
}
.chat_dig .kefu_jilu .messages .message.left .text_wrapper::after,
.chat_dig .kefu_jilu .messages .message.left .text_wrapper::before {
    right: 100%;
    border-right-color: #ffe6cb;
}
.chat_dig .kefu_jilu .messages .message.left .text {
    color: #c48843;
    line-height:30px;
}
.chat_dig .kefu_jilu .messages .message.left .time {
    position: absolute;
    top:-2px;
    right:10px;
    color:#aaa;
    height:20px;
    line-height: 20px;
}
.chat_dig .kefu_jilu .messages .message.right .avatar {
    /* background-color: #fdbf68; */
    float: right;
}
.chat_dig .kefu_jilu .messages .message.right .text_wrapper {
    background-color: #c7eafc;
    margin-right: 20px;
    float: right;
}
.chat_dig .kefu_jilu .messages .message.right .text_wrapper::after,
.chat_dig .kefu_jilu .messages .message.right .text_wrapper::before {
    left: 100%;
    border-left-color: #c7eafc;
}
.chat_dig .kefu_jilu .messages .message.right .text {
    color: #45829b;
    text-align: right;
    line-height:30px;
}
.chat_dig .kefu_jilu .messages .message.right .time {
    position: absolute;
    top:-2px;
    left:10px;
    color:#aaa;
    height:20px;
    line-height: 20px;
}
.chat_dig .kefu_jilu .messages .message.appeared {
    opacity: 1;
}
.chat_dig .kefu_jilu .messages .message .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: inline-block;
}
.chat_dig .kefu_jilu .messages .message .text_wrapper {
    display: inline-block;
    padding: 20px;
    border-radius: 6px;
    width: calc(100% - 85px);
    min-width: 100px;
    position: relative;
}
.chat_dig .kefu_jilu .messages .message .text_wrapper::after,
.chat_dig .kefu_jilu .messages .message .text_wrapper:before {
    top: 18px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.chat_dig .kefu_jilu .messages .message .text_wrapper::after {
    border-width: 13px;
    margin-top: 0px;
}
.chat_dig .kefu_jilu .messages .message .text_wrapper::before {
    border-width: 15px;
    margin-top: -2px;
}
.chat_dig .kefu_jilu .messages .message .text_wrapper .text {
    font-size: 18px;
    font-weight: 300;
}
.chat_dig .kefu_jilu .bottom_wrapper {
    position: relative;
    width: 100%;
    background-color: #fff;
    padding: 20px 20px;
    position: absolute;
    bottom: 0;
}
.chat_dig .kefu_jilu .bottom_wrapper .message_input_wrapper {
    display: inline-block;
    height: 50px;
    border-radius: 25px;
    border: 1px solid #bcbdc0;
    width: calc(100% - 160px);
    position: relative;
    padding: 0 20px;
}
.chat_dig .kefu_jilu .bottom_wrapper .message_input_wrapper .message_input {
    border: none;
    height: 100%;
    box-sizing: border-box;
    width: calc(100% - 45px);
    position: absolute;
    outline-width: 0;
    color: gray;
}
.chat_dig .kefu_jilu .bottom_wrapper .message_input_wrapper .el-icon-circle-close{
    position: absolute;
    right:0px;
    top:10px;
    font-size: 28px;
    z-index: 999999999;
    color:#888;
    cursor: pointer;
}
.chat_dig .kefu_jilu .bottom_wrapper .send_message {
    width: 140px;
    height: 50px;
    display: inline-block;
    border-radius: 50px;
    background-color: #a3d063;
    border: 2px solid #a3d063;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s linear;
    text-align: center;
    float: right;
}
.chat_dig .kefu_jilu .bottom_wrapper .send_message:hover {
    color: #a3d063;
    background-color: #fff;
}
.chat_dig .kefu_jilu .bottom_wrapper .send_message .text {
    font-size: 18px;
    font-weight: 300;
    line-height: 48px;
}
.chat_dig .kefu_jilu .message_template {
    display: none;
}
.room_list{
  float: left;
  width:260px;
  height:700px;
  background-color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  color:#111;
  padding: 0px;
  margin: 0px;
  overflow-y: scroll;
}
.room_list ul,li{
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.room_list ul li{
  height:60px;
  width:100%;
  text-align: left;
  /* border-top: 1px solid #ddd; */
  border-bottom: 1px solid #ddd;
  position: relative;
  line-height: 16px;
  font-size: 16px;
  cursor: pointer;
}
.room_list ul li .head{
  position: absolute;
  top:5px;
  left: 3px;
  width:50px;
  height:50px;
}
.room_list ul li .user_name{
  position: absolute;
  top:8px;
  left: 60px;
  width:140px;
  white-space:nowrap;
  overflow: hidden; 
  text-overflow:ellipsis;
}
.room_list ul li .user_name{
  position: absolute;
  top:8px;
  left: 60px;
  width:140px;
}
.room_list ul li .last_time{
  position: absolute;
  top:9px;
  right: 8px;
  width:80px;
  text-align: right;
  color:#777;
  font-size: 14px;
}
.room_list ul li .last_content{
  position: absolute;
  top:36px;
  left: 60px;
  width:180px;
  text-align: left;
  white-space:nowrap;
  overflow: hidden; 
  text-overflow:ellipsis;
  color:#777;
  font-size: 14px;
}
.room_list .room_active{
  /* background-color: #C4C4C5; */
  background-color: #ff0;
}
.room_list .no_read{
  position: absolute;
  width:1px;
  height:1px;
  top:0px;
  right:0px;
}
.used_list{
  float: left;
  width:260px;
  height:700px;
  background-color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  color:#111;
  padding: 0px;
  margin: 0px;
  margin-right:15px;
  overflow-y: scroll;
}
.used_list ul,li{
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.used_list ul li{
  width:242px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  position: relative;
  line-height: 17px;
  font-size: 15px;
  cursor: pointer;
  padding: 10px 0px 10px 10px;
}
.used_list ul li .head{
  position: absolute;
  top:5px;
  left: 3px;
  width:50px;
  height:50px;
}
.right-menu {
    position: absolute;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    color:#111;
}
.right-menu .menu-item {
    font-size: 14px;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
}
.right-menu .menu-item .menu-item_licon {
    width: 16px;
}
.right-menu .menu-item:hover {
    background: #c3c3c3;
}
.right-menu .menu-item_disabled {
    cursor: not-allowed;
}
.chat_dig_his .his_messages {
    position: relative;
    list-style: none;
    padding: 20px 10px 0 10px;
    margin: 0;
    width:750px;
    height: 600px;
    overflow-y: scroll;
}
.chat_dig_his .his_messages .message {
    clear: both;
    overflow: hidden;
    margin-bottom: 20px;
    transition: all 0.5s linear;
    opacity: 0;
}
.chat_dig_his .his_messages .message.left .avatar {
    /* background-color: #f5886e; */
    float: left;
}
.chat_dig_his .his_messages .message.left .text_wrapper {
    background-color: #ffe6cb;
    margin-left: 20px;
}
.chat_dig_his .his_messages .message.left .text_wrapper::after,
.chat_dig_his .his_messages .message.left .text_wrapper::before {
    right: 100%;
    border-right-color: #ffe6cb;
}
.chat_dig_his .his_messages .message.left .text {
    color: #c48843;
}
.chat_dig_his .his_messages .message.right .avatar {
    /* background-color: #fdbf68; */
    float: right;
}
.chat_dig_his .his_messages .message.right .text_wrapper {
    background-color: #c7eafc;
    margin-right: 20px;
    float: right;
}
.chat_dig_his .his_messages .message.right .text_wrapper::after,
.chat_dig_his .his_messages .message.right .text_wrapper::before {
    left: 100%;
    border-left-color: #c7eafc;
}
.chat_dig_his .his_messages .message.right .text {
    color: #45829b;
}
.chat_dig_his .his_messages .message.appeared {
    opacity: 1;
}
.chat_dig_his .his_messages .message .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: inline-block;
}
.chat_dig_his .his_messages .message .text_wrapper {
    display: inline-block;
    padding: 20px;
    border-radius: 6px;
    width: calc(100% - 120px);
    min-width: 100px;
    position: relative;
}
.chat_dig_his .his_messages .message .text_wrapper::after,
.chat_dig_his .his_messages .message .text_wrapper:before {
    top: 18px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.chat_dig_his .his_messages .message .text_wrapper::after {
    border-width: 13px;
    margin-top: 0px;
}
.chat_dig_his .his_messages .message .text_wrapper::before {
    border-width: 15px;
    margin-top: -2px;
}
.chat_dig_his .his_messages .message .text_wrapper .text {
    font-size: 18px;
    font-weight: 300;
}
.no_his_message{
  width: 100%;
  height:360px;
}
.no_his_message p{
  width: 100%;
  margin-top: 300px;
  height:20px;
  line-height: 20px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// list.vue?500d79af